import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectFieldResult } from '@wdx/clmi/clmi-swagger-gen';
import { ContextualDataContext } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import { ApiConfigService } from '../api-config.service';
import { BaseApiService } from '../base-api.service';
import { SelectUrlSegment } from './select-url-segment';

interface ContextualSelectBody {
    lookups: any[];
    context?: ContextualDataContext[];
}

@Injectable({ providedIn: 'root' })
export class SelectApiService extends BaseApiService {
    constructor(http: HttpClient, apiConfig: ApiConfigService) {
        super(http, apiConfig);
    }

    getSelect(selectSource: string): Observable<SelectFieldResult[]> {
        const [selectKey, params] = selectSource.split('?');
        return this.get<SelectFieldResult[]>(
            `${SelectUrlSegment.Select}/${selectKey.toLowerCase()}`,
            params ? { params: new HttpParams({ fromString: params }) } : {},
        );
    }

    getContextualSelect(
        source: string,
        lookups: any[],
        context?: ContextualDataContext[],
    ): Observable<SelectFieldResult[]> {
        const transformedLookups = lookups.map((lookup) => ({
            id: lookup.id,
            lookupType: lookup.lookupType,
        }));

        let body: ContextualSelectBody = { lookups: transformedLookups };
        if (context) {
            body = { lookups: transformedLookups, context };
        }
        return this.post<SelectFieldResult[], ContextualSelectBody>(
            `${SelectUrlSegment.Select}/${source.toLowerCase()}`,
            body,
        );
    }
}
